import React from 'react';
import { Skeleton } from './ui/skeleton';

export const MerchantSkeleton = () => {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="p-4 md:p-6 border-b border-gray-100">
        <div className="flex items-start gap-4">
          <Skeleton className="w-14 h-14 md:w-16 md:h-16 rounded-xl" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-4 w-64" />
            <div className="flex gap-3 mt-2">
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-32" />
            </div>
          </div>
          <Skeleton className="h-6 w-16 rounded-full" />
        </div>
      </div>

      {/* Products */}
      <div className="p-4 md:p-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {[...Array(6)].map((_, i) => (
            <ProductSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export const ProductSkeleton = () => {
  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
      <Skeleton className="aspect-square w-full" />
      <div className="p-3 space-y-2">
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-6 w-24 mt-2" />
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-9 w-full mt-3 rounded-lg" />
      </div>
    </div>
  );
};

export const HomeSkeleton = () => {
  return (
    <div className="space-y-6">
      {[...Array(2)].map((_, i) => (
        <MerchantSkeleton key={i} />
      ))}
    </div>
  );
};

export default HomeSkeleton;
